/* eslint-disable*/

const Tortoise = require('@/assets/js/cb').Tortoise
import {
    homeResolve,
    deepClone
} from '@/util'

import {
  TrackIconCase,
  FixIconCase,
  LinkedTagDefaultStyle,
  LinkedTagSrcStyle
} from '@/components/typhoon_tw/settings'

(function (window, document, undefined) {

L.TyphoonTW = L.TyphoonTW || {};

L.TyphoonTW.TrackIconCase = TrackIconCase;

L.TyphoonTW.FixIconCase = FixIconCase;


L.TyphoonTW.Marker = L.Cyclone.Marker.extend({
    initialize: function (data, options, src, src_infos) {
        this._src = src
        this._src_infos = src_infos
        L.Cyclone.Marker.prototype.initialize.call(this, data, options)
    },

    _markerClick: function () {
        if (this._map) {
            var _latlng = this._latlng;
            var _data = this._data,
                _dtime = this._dtime;

            if (_data && _dtime) {
                try {
                    var name_zhtw = this._src_infos.filter(e => {
                        return e['id'] === this._src
                    })[0]['name_zhtw']
                    var _content = name_zhtw + "<br/>";

                    var lst_time = Date.dtgptime(_dtime).setTimezone(0);
                    _content += lst_time.toLocal().strftime("%m月%d日(%-a) %H時")
                             + "<br/>" + sprintf('%.1fN, %.1fE', _data.lat, _data.lon);

                    var ws_str = "--"
                    if (_data.ws > 0) {
                        ws_str = sprintf("%.1f(m/s)", _data.ws);
                    }
                    _content += "<br/>" + sprintf('最大風速 ' + ws_str);

                    var popup = L.popup({
                        closeButton: false,
                        autoClose: true,
                        closeOnClick: true,
                        className: 'track-tip-popup'
                      }).setLatLng(_latlng)
                        .setContent(_content)
                        .openOn(this._map);
                }
                catch(e) {
                    console.error(e);
                }
            }
        }
    },

    setDTime: function (dtime) {
        this._dtime = dtime;
    },

    onAdd: function (map) {
		this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;

		if (this._zoomAnimated) {
			map.on('zoomanim', this._animateZoom, this);
		}

		this.on('move', this._markerMove);
        this.on('dragend', this._markerMove);
        this.on('click', this._markerClick);

		this._initRadius();

		this._initIcon();
		this.update();
    },

    onRemove: function (map) {
		if (this.dragging && this.dragging.enabled()) {
			this.options.draggable = true;
			this.dragging.removeHooks();
		}
		delete this.dragging;

		if (this._zoomAnimated) {
			map.off('zoomanim', this._animateZoom, this);
		}

		this.off('move', this._markerMove);
        this.off('dragend', this._markerMove);
        this.off('click', this._markerClick);

		for (var key in this._radius_layers) {
            if (this._radius_layers[key]) {
                map.removeLayer(this._radius_layers[key]);
            }
        }
        this._radius_layers = {};

		this._removeIcon();
		this._removeShadow();
    }
})

L.TyphoonTW.Track = L.Cyclone.Track.extend({
    initialize: function (data, options, src, src_infos, tc_info, selected_init_time_z) {
        var self = this;
        self._src = src;
        self._src_infos = src_infos;
        self._tc_info = tc_info;
        self._selected_init_time_z = selected_init_time_z
        L.Cyclone.Track.prototype.initialize.call(self, data, options);
    },

    resetMarker: function(dtime, point) {
        var self = this,
            _point_data = L.extend({}, point);

        if (self.options.markerVisible) {
            if (self._markers[dtime]) {
                self._markers[dtime]._initData(_point_data);
            }
            else {
                var _marker = new L.TyphoonTW.Marker(
                    _point_data,
                    self.options.markerOptions,
                    self._src,
                    self._src_infos
                );

                if (self.options.editable) {
                    _marker.setEditable(true);
                }
                _marker.setRadiusVisible(self.options.radiusVisible);

                // attach event listen
                if (_marker.attach) {
                    _marker.attach('marker-moved', self);
                    _marker.attach('marker-data-setted', self);
                }

                if (self._map) {
                    self._map.addLayer(_marker);
                }
                self._markers[dtime] = _marker;
            }
            self._markers[dtime].setDTime(dtime);
        }
    },

    get_src: function() {
        return this._src;
    },

    get_tc_info: function() {
        return this._tc_info;
    },

    get_init_time_z: function() {
        if (this._data.points) {
            return Object.keys(this._data.points).slice(0)[0];
        }
    },

    get_selected_init_time_z: function () {
        return this._selected_init_time_z;
    }
});

L.TyphoonTW.PastTrack = L.TyphoonTW.Track.extend({
    bindTcName: function () {
        let [last_dt] = Object.keys(this._data.points).slice(-1);
        let lastDatetime = Date.dtgptime(last_dt).setTimezone(0);
        let strExtra = "";

        this.tc_marker = this.getPointMarker(last_dt);
        strExtra = ' ' + lastDatetime.toLocal().formatDate('%d(%-a)%H:%M');
        let tc_src_name = this._tc_info[this._src] ? this._tc_info[this._src] : this._tc_info.name
        let _icon_tag = new L.TyNameTag(this._tc_info.name, tc_src_name + strExtra, {});

        _icon_tag.retrievePosition();
        this.tc_marker.bindTag(_icon_tag);
        this.setTcNameVisible();
    },
    setTcNameVisible: function(visible) {
        if (typeof visible == "undefined") {
            visible = this.tag_visible;
        }
        else {
            this.tag_visible = visible;
        }
        if (this.tc_marker) {
            if (visible) {
                this.tc_marker.showTag();
            }
            else {
                this.tc_marker.hideTag();
            }
        }
    }
});

L.TyphoonTW.FcstTrack = L.TyphoonTW.Track.extend({
    onAdd: function (map) {
        let _th = this._th;
        this._map = map;

        this._renderer._initPath(this);
        this._reset();

        if (!this.options.hidePath) {
            this._project();
            this._updatePath();
        }

        if (this.options.markerVisible) {
            for (var dtime in this._markers) {
                let _marker = this._markers[dtime]
                let _tau = _marker.getData().tau
                map.addLayer(_marker);
                var _dt_utc = Date.dtgptime(dtime, '%Y%m%d%H').setTimezone(0);
                if (this.options.timeLabelTimeList.includes(dtime)) {
                    _th.trigger('time_label:onboard', {
                        layer: this._markers[dtime],
                        dtime: _dt_utc,
                        tc_id: this.get_tc_info().name
                    });
                }
            }
        }
		    this._renderer._addPath(this);
    },

	  onRemove: function () {
        let _th = this._th;
        for (var dtime in this._markers) {
            let _marker = this._markers[dtime];
            this._map.removeLayer(this._markers[dtime]);
            _th.trigger('time_label:offboard', {
                layer: _marker,
                tc_id: this.get_tc_info().name
            });
        }
		    this._renderer._removePath(this);
    },

    bindSrcName: function () {
        let [last_dt] = Object.keys(this._data.points).slice(-1);

        let name_zhtw = this._src_infos.filter(e => {
            return e['id'] === this._src
        })[0]['name_zhtw']

        this.srcTagMarker = this.getPointMarker(last_dt);
        if (this.srcTagMarker) {
            this.srcTagMarker.bindTag(
                name_zhtw,
                LinkedTagSrcStyle);
        }
    },

    setSrcNameVisible: function (visible) {
        if (this.srcTagMarker) {
            if (visible) {
                this.srcTagMarker.showTag();
            } else {
                this.srcTagMarker.hideTag();
            }
        }
    },

    bindTimeLabelHub: function (th) {
        this._th = th;
    }
});

L.TyNameTag = L.LinkedTag.extend({
    options: {
        className: '',
        clickable: false,
        draggable: true,
        noHide: true,
        zoomAnimation: true,
        ...LinkedTagDefaultStyle
    },

    initialize: function (tc_id, content, options) {
        L.setOptions(this, options);

        this._tc_id = tc_id;
        this._source = null;
        this._content = content;
        this._animated = L.Browser.any3d && this.options.zoomAnimation;
        this._isOpen = false;
    },

    _updateContent: function () {
        if (!this._content || !this._map || this._prevContent === this._content) {
            return;
        }

        if (typeof this._content === 'string') {
            var ctx = null;

            if (this._content_canvas) {
                ctx = this._content_canvas.getContext("2d");
                ctx.clearRect(0, 0, this._content_canvas.width, this._content_canvas.height);
            }
            else {
                this._content_canvas = L.DomUtil.create('canvas', '');
                this._container.appendChild(this._content_canvas);
                ctx = this._content_canvas.getContext("2d");
            }

            var _icon_width = 0, _icon_height = 24;
            if (this.options.icon) {
                try {
                    _icon_width = this.options.icon.size[0];
                    _icon_height = this.options.icon.size[1];
                }
                catch(e){}
            }

            if (this.options.font) {
                ctx.font = this.options.font;
            }
            var txtWidth = this._measureTextWidth(ctx, this._content, this.options['letterSpacing']) + _icon_width;
            var canvasHeight = 0;
            var txtHeight = 0;
            txtHeight = canvasHeight = _icon_height;
            try {
                var _font_size = ctx.font.split(' ')[0];
                txtHeight = canvasHeight = this._parse_str_to_int(_font_size);
                if (_icon_height > txtHeight) {
                    txtHeight = canvasHeight = _icon_height;
                }
            }
            catch(e) {}

            var _padding_left = 0, _padding_top = 0, _padding_right = 0, _padding_bottom = 0;
            if (this.options.padding) {
                var _type = typeof(this.options.padding);
                if (_type == 'string') {
                    var _txts = this.options.padding.split(' ');
                    if (_txts.length > 0) {
                        _padding_top = this._parse_str_to_int(_txts[0]);
                        if (_txts.length == 1) {
                            _padding_left = _padding_bottom = _padding_right = _padding_top;
                        }
                        else if (_txts.length >= 4) {
                            _padding_right = this._parse_str_to_int(_txts[1]);
                            _padding_bottom = this._parse_str_to_int(_txts[2]);
                            _padding_left = this._parse_str_to_int(_txts[3]);
                        }
                        else {
                            _padding_left = _padding_right = this._parse_str_to_int(_txts[1]);
                            _padding_bottom = _padding_top;
                        }
                    }
                }
                else if (_type == 'number') {
                    _padding_left = _padding_right = this.options.padding;
                    _padding_top = _padding_bottom = this.options.padding;
                }
            }

            var _border = 0;
            var _top_buffer = 0;
            if (this.options['border-width']) {
                var _type = typeof(this.options['border-width']);
                if (_type == 'string') {
                    _border = this._parse_str_to_int(this.options['border-width']);
                }
                else if (_type == 'number') {
                    _border = this.options['border-width'];
                }
                _padding_left += _border;
                _padding_top += _border;
            }

            if (_padding_left > 0 || _padding_right > 0) {
                txtWidth += (_padding_left + _padding_right);
            }
            if (_padding_top > 0 || _padding_bottom > 0) {
                canvasHeight += (_padding_top + _padding_bottom);
            }

            if (this.options['border-radius']) {
                txtWidth += 2;
                canvasHeight += 2;
            }

            this._content_canvas.width = txtWidth;
            this._content_canvas.height = canvasHeight;

            if (this.options.fillColor) {
                ctx.fillStyle = this.options.fillColor;
            }
            if (this.options['border-radius']) {
                if (_border) {
                    ctx.strokeStyle = this.options['border-color'];
                }
                this.roundRect(ctx, 0, 0, txtWidth-2, canvasHeight-2,
                    this.options['border-radius'], _border,
                    this.options.fillColor);
            }
            else if (_border) {
                ctx.fillRect(0, 0, txtWidth, canvasHeight);
                ctx.lineWidth = _border;
                if (this.options['border-color']) {
                    ctx.strokeStyle = this.options['border-color'];
                }
                ctx.strokeRect(0+(_border/2), 0+(_border/2), txtWidth-_border, canvasHeight-_border);
            }
            else {
                ctx.fillRect(0, 0, txtWidth, txtHeight);
            }

            if (this.options['border-radius']) {
                _top_buffer = 4;
            }
            else {
                _top_buffer = 3;
            }

            ctx.fillStyle = this.options['font-color'];

            if (this.options.icon && this.options.icon.src) {
                var drawing = new Image();
                drawing._left = _padding_left;
                drawing.onload = function() {
                   ctx.drawImage(drawing, this._left, _padding_top,
                       _icon_width, _icon_height);
                };
                drawing.src = this.options.icon.src;
                _padding_left += (_icon_width + this.options['letterSpacing']);
            }

            if (this.options.font) {
                ctx.font = this.options.font;
            }
            this._fillText(ctx, this._content,
                _padding_left, txtHeight + _padding_top - _top_buffer,
                this.options['letterSpacing']);
        }
    },

    retrievePosition: function() {
        if (typeof(Storage) !== "undefined") {
            var posoffset = localStorage['tc_name_tag_' + this._tc_id];
            if (posoffset) {
                posoffset = JSON.parse(posoffset);
                if (posoffset.latlng) { this._latlng = L.latLng(posoffset.latlng); }
                if (posoffset.offset) { this._offset = L.point(posoffset.offset.x, posoffset.offset.y); }
            }
        }
    },

    resetPosition: function(pos) {
        var offx = parseInt(this._container.clientWidth / 2.0 + 0.5),
            offy = parseInt(this._container.clientHeight / 2.0 + 0.5);

        var marker_pos = this._map.latLngToLayerPoint(this._latlng);

        this._pos = pos.add(L.point(offx, offy));
        this._offset = this._pos.subtract(marker_pos);
        this._setLinePosition(this._pos);

        var posoffset = JSON.stringify({
            latlng: {lat:this._latlng.lat, lng: this._latlng.lng},
            offset: {x:this._offset.x, y: this._offset.y}
        });
        localStorage.setItem("tc_name_tag_"+this._tc_id, posoffset);
    }
});

L.TrackShell = L.ShellLayer.extend({
    getInstanceProps: function () {
        if (this._layer && this._data.points) {
            return [
                this._layer.get_src(),
                this._layer.get_tc_info(),
                [Object.keys(this._data.points).slice(0)]
            ]
        }
        return []
    },

    takeOut: function(layer) {
        var self = this;
        self._layer = layer;
        if (self._layer) {
            if (self._map) {
                if (self._map.hasLayer(self._layer)) {
                    self._map.removeLayer(self._layer);
                }
            }
        }
    },
})

L.TyphoonTW.LabelCarrier = L.LabelCarrier.extend({
    retrievePosition: function(tc_id, tau) {
        this._tau = tau;
        var posoffset;
        // if (GV.prefs.tlo && GV.prefs.tlo[tc_id]) {
        //     posoffset = GV.prefs.tlo[tc_id][tau];
        //     if (posoffset) { this._offset = L.point(posoffset[0], posoffset[1]); }
        // }
        // else
        if (typeof(Storage) !== "undefined") {
            posoffset = localStorage['tc_tau_lab_' + tc_id + tau];
            if (posoffset) {
                posoffset = JSON.parse(posoffset);
                if (posoffset.offset) { this._offset = L.point(posoffset.offset.x, posoffset.offset.y); }
            }
        }
    },

    resetPosition: function(pos) {
        var offx = parseInt(this._container.clientWidth / 2.0 + 0.5),
            offy = parseInt(this._container.clientHeight / 2.0 + 0.5);

        var marker_pos = this._map.latLngToLayerPoint(this._latlng);

        this._pos = pos.add(L.point(offx, offy));
        this._offset = this._pos.subtract(marker_pos);
        this._setLinePosition(this._pos);

        var posoffset = JSON.stringify({
            latlng: {lat:this._latlng.lat, lng: this._latlng.lng},
            offset: {x:this._offset.x, y: this._offset.y}
        });
        localStorage.setItem("tc_tau_lab_"+this._hub._tc_id+this._tau, posoffset);
    }
});


L.TyphoonTW.TimeLabelCarrierHub = L.TimeLabelCarrierHub.extend({
    options: {
        LST: true,
        format: "%d(%-a)%H:%M",
        labelOptions: {},
        label: L.TyphoonTW.LabelCarrier
    },

    initialize: function(map, tc_id, options) {
        var self = this;
        self._tc_id = tc_id;

        self._tau_selected = {
            '24': true,
            '48': true,
            '72': true
        };
        self._visible = false;
        // if (GV.prefs.tlo !== null) {
        //     if (GV.prefs.tlo === 1) { //pass
        //     } else {
        //         if (GV.prefs.tlo[tc_id]){
        //             self._tau_selected['24'] = GV.prefs.tlo[tc_id][24] ? true:false;
        //             self._tau_selected['48'] = GV.prefs.tlo[tc_id][48] ? true:false;
        //             self._tau_selected['72'] = GV.prefs.tlo[tc_id][72] ? true:false;
        //         }
        //         else {
        //             self._tau_selected = {
        //                 '24': false,
        //                 '48': false,
        //                 '72': false
        //             };
        //         }
        //     }
        // }

        L.TimeLabelCarrierHub.prototype.initialize.call(self, map, options);

        // self.set_init(Date.strptime(options.first_dt, '%Y%m%d%H'));
        self.set_init();

        // CB.EventCentre.on(CB.EventTypes.Time_Label_Show, function (e, data) {
        //     // data = {visible: boolean}
        //     self._visible = data.visible;
        //     self.remap();
        // });

        // CB.EventCentre.on(CB.EventTypes.Time_Label_Tau_Selected, function (e, data) {
        //     // data = {tau: number, visible: boolean}
        //     if (data.visible) {
        //         if (!self._tau_selected[data.tau]) {
        //             self._tau_selected[data.tau] = true;
        //         }
        //     }
        //     else {
        //         if (self._tau_selected[data.tau]) {
        //             self._tau_selected[data.tau] = false;
        //         }
        //     }
        //     self.remap();
        // });

        // CB.EventCentre.on(CB.EventTypes.Layer_On_Board, function (e, data) {
        //     // data = {layer: L.Layer, dtime: Date}
        //     if (data.tc_id == self._tc_id) {
        //         self.onboard(data.dtime, data.layer);
        //     }
        // });

        // CB.EventCentre.on(CB.EventTypes.Layer_Off_Board, function (e, data) {
        //     // data = {layer: L.Layer}
        //     if (data.tc_id == self._tc_id) {
        //         self.offboard(data.layer);
        //     }
        // });
    },

    onboard: function(dtime, layer, tau) {
        //
        // dtime is Date object or number by Date.getTime()
        //
        //if (dtime instanceof Date) {
        //    dtime = dtime.getTime();
        //}
        var self = this;
        self.setContent(dtime);
        if (dtime instanceof Date) {
            dtime = dtime.getTime();
        }
        L.LabelCarrierHub.prototype.onboard.call(self, dtime, layer);
    },

    set_init: function(init) {
        if (init instanceof Number) {
            init = new Date(init);
        }
        this._init = init;
        this.remap();
    },

    addToMap: function(label) {
        var self = this;
        if (self._map) {
            for (var key in self._carries) {
                var carrie = self._carries[key];
                if (label == carrie && self._visible) {
                    carrie.retrievePosition(self._tc_id, key);
                    self._map.addLayer(carrie);
                    break;
                }
            }
            for (var key in self._carries) {
                var carrie = self._carries[key];
                if (label == carrie && self._map && !self._visible) {
                    self._map.removeLayer(carrie);
                    break;
                }
            }
        }
    },

    setVisible: function (visible) {
        this._visible = visible;
        this.remap()
    },

    get_tc: function () {
        return this._tc_id;
    }
});

}(this, document));



// WEBPACK FOOTER //
// ./src/assets/leaflet/track/typhoontw_leaflet.js